import React, { useEffect, useState } from 'react';
import { Box, useToast, useDisclosure } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import UserSearchBox from './UserSearchBox';
import UserSearchResults from './UserSearchResults';
import { searchCommunityUsers, updateCommunityUserFilters } from '../../Redux/Mode/action';
import SendMessageModal from '../../components/Messages/SendMessageModal';

const UserFinderTab = () => {
  const dispatch = useDispatch();
  const toast = useToast();
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [hasPerformedSearch, setHasPerformedSearch] = useState(false);
  const { isOpen: isMessageModalOpen, onOpen: openMessageModal, onClose: closeMessageModal } = useDisclosure();
  
  const {
    results = [],
    loading = false,
    error = null,
    filters = {},
    totalResults = 0,
    currentPage = 1,
    totalPages = 1,
  } = useSelector(state => state.Mode?.community?.userSearch || {});

  const handleSearch = (newFilters = {}) => {
    const searchParams = { ...filters, ...newFilters };
    const apiParams = {
      q: searchParams.query || '',
      page: searchParams.page || 1,
      limit: searchParams.limit || 12
    };
    dispatch(updateCommunityUserFilters(newFilters));
    dispatch(searchCommunityUsers(apiParams));
    setHasPerformedSearch(true);
  };
  
  const handlePageChange = (page) => {
    handleSearch({ page });
  };
  
  const handleMessageUser = (burrowerId) => {
    setSelectedRecipient(burrowerId);
    openMessageModal();
  };
  
  useEffect(() => {
    if (error) {
      toast({
        title: "Search Error",
        description: typeof error === 'string' ? error : 'Failed to search users',
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  }, [error, toast]);

  return (
    <Box>
      <UserSearchBox 
        onSearch={handleSearch} 
        initialQuery={filters?.query} 
      />
      <UserSearchResults 
        results={results}
        loading={loading}
        totalResults={totalResults}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onMessageUser={handleMessageUser}
        hasSearched={hasPerformedSearch}
      />
      <SendMessageModal 
        isOpen={isMessageModalOpen} 
        onClose={closeMessageModal}
        initialRecipient={selectedRecipient}
      />
    </Box>
  );
};

export default UserFinderTab;
